import React from 'react';
import { cn } from '@/lib/utils';

/**
 * The Library's own marks, drawn to sit with lucide (24 grid, 1.6 stroke,
 * round joins) but shaped after what they open: Everything is a small
 * masonry of tiles, Spaces a fanned pile of cards like the space covers.
 * Active tabs fill; resting tabs are outlines.
 */

const line = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.6, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const };

export function EverythingIcon({ active = false, className }: { active?: boolean; className?: string }) {
  const tile = active ? { fill: 'currentColor', stroke: 'currentColor', strokeWidth: 1.6, strokeLinejoin: 'round' as const } : line;
  return (
    <svg viewBox="0 0 24 24" className={cn('h-6 w-6', className)} aria-hidden>
      <rect x="3.8" y="3.8" width="7.2" height="9.6" rx="2.2" {...tile} />
      <rect x="3.8" y="15.6" width="7.2" height="4.6" rx="2" {...tile} />
      <rect x="13" y="3.8" width="7.2" height="4.6" rx="2" {...tile} />
      <rect x="13" y="10.6" width="7.2" height="9.6" rx="2.2" {...tile} />
    </svg>
  );
}

export function SpacesIcon({ active = false, className }: { active?: boolean; className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={cn('h-6 w-6', className)} aria-hidden>
      {/* The card behind, turned a little, like the covers in Spaces */}
      <rect x="6.4" y="3.2" width="11.2" height="14" rx="2.6" transform="rotate(-12 12 10.2)" {...line} opacity={active ? 0.55 : 1} />
      <rect
        x="6.4"
        y="6.6"
        width="11.2"
        height="14"
        rx="2.6"
        {...(active ? { fill: 'currentColor', stroke: 'currentColor', strokeWidth: 1.6, strokeLinejoin: 'round' as const } : line)}
      />
    </svg>
  );
}

/** A pencil over a ruled line: "write a note". */
export function NoteGlyph({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={cn('h-5 w-5', className)} aria-hidden>
      <path d="M14.6 5.2 18.8 9.4 9.4 18.8H5.2V14.6Z" {...line} />
      <path d="M12.6 7.2 16.8 11.4" {...line} />
      <path d="M13 19.2h6" {...line} />
    </svg>
  );
}
